import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import PopUpContentWrapper from 'src/components/PopUpContentWrapper';
import Button from 'src/components/design-system/Button';
import PopUp from 'src/components/design-system/PopUp';
import {
  BackButtonPermissions,
  CancelButtonPermissions,
} from 'src/sections/view_invoice_budget_period/index';
import { hasPermission } from 'src/utils/JWT';
import { useContextSelector } from 'use-context-selector';
import { InvoiceContext } from '../invoice_details/InvoiceDetailsContext';

interface BudgetInvoicePeriodNavBarProps {
  onCancel: VoidFunction;
  onSave: VoidFunction;
  errorList: string[];
  showErrorPopUp: boolean;
  isSaveDisabled: boolean;
  isSaveLoading: boolean;
}

const InvoiceBudgetPeriodNavBar: FC<BudgetInvoicePeriodNavBarProps> = ({
  onCancel,
  onSave,
  errorList,
  showErrorPopUp,
  isSaveDisabled,
  isSaveLoading,
}) => {
  const { t } = useTranslation();
  const mpaPermissionNumber = useContextSelector(
    InvoiceContext,
    (value) => value.mpaPermissionNumber
  );
  const isInvoiceMPAEditable = useContextSelector(
    InvoiceContext,
    (value) => value.isInvoiceMPAEditable
  );
  const handleCancel = useCallback(() => {
    onCancel();
  }, [onCancel]);

  const isShowCancelButton = hasPermission(CancelButtonPermissions, mpaPermissionNumber);
  const isShowBackButton = hasPermission(BackButtonPermissions, mpaPermissionNumber);

  return (
    <section>
      <div className="flex items-center">
        {isShowCancelButton && (
          <Button onClick={handleCancel} size={'md'} color={'info'} disabled={isSaveLoading}>
            {t('Cancel')}
          </Button>
        )}
        {isShowBackButton && (
          <Button onClick={handleCancel} size={'md'} color={'info'}>
            {t('Back')}
          </Button>
        )}
        {isInvoiceMPAEditable && (
          <PopUp
            popupAlign={{ horizontal: 'center', vertical: 'top' }}
            content={
              <div className="m-1 max-w-[350px]">
                <PopUpContentWrapper type="Error" contents={errorList} />
              </div>
            }
            show={showErrorPopUp}
          >
            <Button onClick={onSave} size={'md'} disabled={isSaveDisabled} loading={isSaveLoading}>
              {t('Save')}
            </Button>
          </PopUp>
        )}
        <p className="font-bold font-md pl-2">
          {isInvoiceMPAEditable
            ? t('Manage Accounting Period Allocations')
            : t('View Period Allocations')}
        </p>
      </div>
    </section>
  );
};

export default InvoiceBudgetPeriodNavBar;
